import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import Grid from "@material-ui/core/Grid";
import { useForm } from "react-hook-form";

export default function DeviceProtection(props) {
  // eslint-disable-next-line no-unused-vars
  const { register, errors, handleSubmit } = useForm();
  const onSubmit = (data) => {
    props.onSubmit(data);
  };
  const [deviceProtectionToggle, setDeviceProtectionToggle] = useState("No");
  const deviceProtectionChange = (event) => {
    setDeviceProtectionToggle(event.target.value);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Would you like to purchase and additional Device Protection Plan for
            $49.99 per month? This includes:
            <ul>
              <li>Repair support any time during business hours.</li>
              <li>
                Free shipping on all repairs with no deductibles or hidden fees
              </li>
              <li>Coverage for product breakdowns and malfunctions.</li>
            </ul>
            By purchasing this Protection Plan you agree to the Device
            Protection Plan Terms and Conditions.
          </Typography>
        </Grid>
        <Grid item md={6}>
          <Grid container direction="column" spacing={0}>
            <Grid item xs={12}>
              <Radio
                color="#464d7c"
                checked={deviceProtectionToggle === "Yes"}
                onChange={deviceProtectionChange}
                label={"Yes"}
                value="Yes"
                id="yesprotection"
                name="device_protection"
                inputProps={{ "aria-label": "Yes" }}
                inputRef={register({ required: true })}
              />
              <label for="yesprotection">
                <Typography variant="caption">
                  Yes, I would like to purchase device protection.
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12}>
              <Radio
                color="#464d7c"
                checked={deviceProtectionToggle === "No"}
                onChange={deviceProtectionChange}
                value="No"
                id="noprotection"
                name="device_protection"
                inputProps={{ "aria-label": "No" }}
                inputRef={register()}
              />
              <label for="noprotection">
                <Typography variant="caption">
                  No, I would not like to purchase device protection.
                </Typography>
              </label>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button
            style={{ background: "#464d7c" }}
            id="submit"
            type="submit"
            name="submit"
            label="Submit"
            size="large"
            variant="contained"
            color="primary"
            disableElevation
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
